import { useLingui } from "@lingui/react";
import { formatNumber } from "@mobility-item-page/utilities";
import { useAppConfig } from "src/context/AppConfigProviderContext.tsx";
import FieldValuePair from "../../FieldValuePair.tsx";
import type { SpecProps } from "../types.ts";

export const Co2Emissions = ({ co2Emissions }: SpecProps<"co2_emissions">) => {
  const { i18n } = useLingui();
  const { locale } = useAppConfig();

  if (co2Emissions == null || co2Emissions === 0) {
    return null;
  }

  const field = i18n.t({
    id: "itemPageLayout.keyInfo.co2_emissions",
    message: "CO₂ emissions",
    comment: "Field for 'CO2 emissions' in ad specification",
  });
  const value = i18n.t({
    id: "itemPageLayout.keyInfo.co2_emissions.postfix",
    message: "{emissions} g/km",
    comment: "CO2 emissions postfix in ad specification",
    values: {
      emissions: formatNumber(co2Emissions, locale),
    },
  });
  return <FieldValuePair field={field} value={value} />;
};
